import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { css } from '@bd/bdui-styles/emotion';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import MenuAbout from '../../components/MenuAbout';
import ContactFormModal from './ContactFormModal';

const styles = css`
  .pageContainer {
    padding:60px 0;
    margin-bottom:60px;
    border-bottom:1px solid #eee;
  }
`;

function ThankYou({ page, builder }) {
  return (
    <div className={styles}>
      <PageWrapper>
        <PageHelmet page={page} />
        <InsideHeader
          h1={`${page.page_title[0].title}`}
          h1Pre={`${page.page_title[0].pretitle}`}
          leadText={`${page.lead_copy}`}
        />
        <MenuAbout />
        <div className="container pageContainer">
          <div className="row m-0">
            <div className="col-md-4">
              <ul className="list-unstyled">
                {get(builder, 'name') &&
                  <li>
                    <strong>{get(builder, 'name')}</strong>
                  </li>
                }
                {get(builder, 'address.streetAddress') &&
                  <li>
                    {get(builder, 'address.streetAddress')}
                  </li>
                }
                {get(builder, 'address.addressLocality') &&
                  <li>
                    {get(builder, 'address.addressLocality')}, {get(builder, 'address.addressRegion')} {get(builder, 'address.postalCode')}
                  </li>
                }
                {get(builder, 'telephone') &&
                  <li>
                    <a href={`tel:${get(builder, 'telephone', '').replace(/[^0-9]/g, '')}`}>{builder.telephone}</a>
                  </li>
                }
              </ul>
            </div>
            <div className="col-md-8">
              <ContactFormModal />
            </div>
          </div>
        </div>
      </PageWrapper>
    </div>
  );
}

ThankYou.propTypes = {
  page: PropTypes.object.isRequired,
  builder: PropTypes.object.isRequired,
};

export default withData({
  page: 'thank_you',
  builder: true,
})(ThankYou);



// WEBPACK FOOTER //
// ./src/pages/ContactUs/ThankYou.js